import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { CanonicalService } from '../../shared/canonical.service';
@Component({
  selector: 'app-about-mobile-security',
  templateUrl: './about-mobile-security.component.html',
  styleUrls: ['./about-mobile-security.component.css'],
})
export class AboutMobileSecurityComponent implements OnInit {
  heading = "MProtectt: Your Mobile Privacy Guard";
  subheading = "Your personal data is everywhere.";
  innerWidth:number = window.innerWidth;
  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private metaTagService1: Meta,
    private canonicalService: CanonicalService
  ) { 
    this.canonicalService.setCanonicalURL("https://www.protectt.ai/mprotectt");
    this.innerWidth = window.innerWidth;
  }
  title = 'MProtectt is Mobile AntiVirus App providing security against Viruses, Malwares, Spywares, Web Security & Wi-Fi Security';
  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.metaTagService1.updateTag({name: 'title', content: 'Mobile Security and Privacy App for Android & iOS | MProtectt | Protectt.ai'});
    this.metaTagService.updateTag({ name: 'description', content: "MProtectt is Mobile AntiVirus that provides security against Malware, Spyware, Web Security & Wi-Fi Security. Get the best mobile privacy guard!"});
    this.metaTagService.addTags([
      {
        name: 'keywords',
        content:
          'MProtectt, Mobile Antivirus, Android Security, Mobile Security',
      },
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'mprotectt.protectt.ai' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { name: 'date', content: '01-06-2021', scheme: 'DD-MM-YYYY' },
      { charset: 'UTF-8' },
    ]);
  }
  onResize(event:any){
    this.innerWidth = event.target.innerWidth;
  }
}
